const DEFAULT_LANGUAGE = 'de';

export const generateLangForPayload = (
  activeLanguage: string | undefined | null,
  manifestLanguages: Record<string, string> | undefined | null
): string => {
  const normalizedActiveLanguage = activeLanguage?.split('-')[0]?.toLowerCase() || '';
  const supportedLanguages = Object.values(manifestLanguages || {}).map((lang) =>
    lang.toLowerCase()
  );

  if (normalizedActiveLanguage && supportedLanguages.includes(normalizedActiveLanguage)) {
    return normalizedActiveLanguage;
  }

  return DEFAULT_LANGUAGE;
};
